import { Bell, Boxes, LifeBuoy, Link2, Map as MapIcon, MapPin, Receipt, Settings, Truck, Users, Workflow } from 'lucide-react';
import type { AppNavEntry } from '@/components/shell/app-sidebar';
import { siteUrl } from './appUrls';

export type RouteKey = 'map' | 'assets' | 'shipments' | 'places' | 'rules' | 'alerts' | 'share-links' | 'team' | 'orders' | 'settings' | 'help';

export const NAV_ENTRIES: AppNavEntry[] = [
  { key: 'map', title: 'Map', href: '/map', icon: MapIcon },
  { key: 'assets', title: 'Assets', href: '/assets', icon: Boxes },
  { key: 'shipments', title: 'Shipments', href: '/shipments', icon: Truck },
  { key: 'places', title: 'Places', href: '/places', icon: MapPin },
  { key: 'rules', title: 'Rules', href: '/rules', icon: Workflow },
  { key: 'alerts', title: 'Alerts', href: '/alerts', icon: Bell },
  { key: 'share-links', title: 'Share links', href: '/share-links', icon: Link2 },
  { type: 'section', title: 'Workspace' },
  { key: 'team', title: 'Team', href: '/team', icon: Users },
  { key: 'orders', title: 'Orders', href: '/orders', icon: Receipt },
  { key: 'settings', title: 'Settings', href: '/settings', icon: Settings },
  { key: 'help', title: 'Help', href: siteUrl('/support/'), icon: LifeBuoy, isExternal: true, bottom: true },
];

/** Stable URLs across workspace types. Personal workspaces omit business operations. */
export function navForWorkspace(kind: 'personal' | 'team'): AppNavEntry[] {
  return NAV_ENTRIES.filter((entry) => 'type' in entry || kind === 'team' || !['shipments', 'team'].includes(entry.key));
}
export function isPathActive(navHref: string, currentPath: string): boolean {
  return navHref.startsWith('/') && (currentPath === navHref || currentPath.startsWith(`${navHref}/`));
}
